import ChampVisuelParameter from "@/components/practitioner/champVisuel/ChampVisuelParameter";

export default function CVParams() {
  return (
    <div className="w-full flex justify-center mt-6">
    <ChampVisuelParameter/>
  </div>
  );
}